import * as React from 'react'

import { cn } from '@/lib/utils'
import { fieldBox } from './input'

/**
 * Spec 06 · Textarea — same box as Input, no resize handle; the
 * character counter lives in the label row (see Field).
 */
const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, placeholder, rows = 3, ...props }, ref) => (
    <textarea
      ref={ref}
      rows={rows}
      placeholder={placeholder ?? ' '}
      className={cn(fieldBox, 'resize-none px-3.5 py-[13px] leading-[1.55]', className)}
      {...props}
    />
  )
)
Textarea.displayName = 'Textarea'

export { Textarea }
